import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutGrid, Scale, ClipboardList, Calculator, FlaskConical, BookOpen, Network, TrendingUp, Users, LogOut } from "lucide-react";

const NAV = [
  { to: "/produzione", label: "Dashboard", icon: LayoutGrid, end: true },
  { to: "/produzione/resa-rapida", label: "Resa rapida", icon: Scale },
  { to: "/produzione/lavorazioni", label: "Lavorazioni", icon: ClipboardList },
  { to: "/produzione/calcolatore", label: "Calcolatore", icon: Calculator },
  { to: "/produzione/simulazioni", label: "Simulazioni", icon: FlaskConical },
  { to: "/produzione/ricette", label: "Ricette", icon: BookOpen },
  { to: "/produzione/albero", label: "Albero", icon: Network },
  { to: "/produzione/storico", label: "Storico", icon: TrendingUp },
  { to: "/produzione/utenti", label: "Utenti", icon: Users, admin: true },
];

export default function ProdLayout({ user, onLogout, children }) {
  const navigate = useNavigate();
  const items = NAV.filter((n) => !n.admin || user?.role === "admin" || user?.role === "superadmin");
  return (
    <div className="min-h-screen bg-[#0F172A] text-slate-100 font-['IBM_Plex_Sans']">
      <header className="bg-slate-900/95 backdrop-blur border-b border-slate-800 sticky top-0 z-40">
        <div className="max-w-[1500px] mx-auto px-3 md:px-6">
          <div className="flex items-center justify-between h-16">
            <button onClick={() => navigate("/produzione")} className="flex items-baseline gap-2" data-testid="prod-brand">
              <span className="font-['Chivo'] font-black text-2xl tracking-tighter text-white">PRODU<span className="text-blue-500">ZIONE</span></span>
              <span className="hidden sm:inline text-[10px] font-bold uppercase tracking-[0.3em] text-slate-500">Rese & Costi</span>
            </button>
            <div className="flex items-center gap-3">
              <span className="hidden md:inline text-sm text-slate-400" data-testid="prod-user-name">
                {user?.name}{user?.is_manager && <span className="ml-2 text-[10px] font-bold uppercase tracking-wider text-blue-400">Responsabile</span>}
              </span>
              <button onClick={onLogout} className="h-11 px-4 rounded-xl flex items-center gap-2 text-sm font-bold text-slate-300 hover:bg-slate-800 border border-slate-700" data-testid="prod-logout">
                <LogOut className="w-4 h-4" /> Esci
              </button>
            </div>
          </div>
          <nav className="flex overflow-x-auto -mx-1 gap-1 pb-2" data-testid="prod-nav">
            {items.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`prod-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 h-12 rounded-xl font-bold text-sm whitespace-nowrap transition-colors ${isActive ? "bg-blue-600 text-white" : "text-slate-400 hover:text-white hover:bg-slate-800"}`
                }
              >
                <n.icon className="w-4 h-4" /> {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="max-w-[1500px] mx-auto px-3 md:px-6 py-5 md:py-8">{children}</main>
    </div>
  );
}
